export default {
	heading: "New 1:1 Relationship",
	createButton: "Create 1:1",
	cancelButton: "Cancel",
	subHeading: "Your Teammate",
	whoIsRelationshipWithHint: "Who is this 1:1 relationship with?",
	emailFieldLabel: "Their email",
	emailFieldPlaceholder: "e.g., snape{'@'}hogwarts.edu",
	emailFieldHint: "Enter the email of the person you wish to invite to this 1:1. If we find an Opre user with that email, they will be displayed in a list.",
	roleFieldLabel: "Their role",
	roleFieldHint: "Does this person report to you, manage you, or is this a peer relationship?",
	emailFieldValidationError1: "A valid email address is required.",
	emailFieldValidationError2: "It seems you are already in this 1:1. Invite someone else?",
	deferTitle: "Defer Invitation",
	deferDescription: "If you’re not quite ready for us to send an invitation to your teammate, check this box. You’ll be able to send the invitation later on.",
};
